document.addEventListener('DOMContentLoaded', () => {
    const bigQuote = document.querySelectorAll('.module_bigquote');

    bigQuote.forEach(bquoteSlider => {
        let num = 1;

        const slider = bquoteSlider.querySelector('.swiper');
        const paginationElement = bquoteSlider.querySelector('.swiper-pagination');
        const nextButton = bquoteSlider.querySelector('.swiper-button-next');
        const prevButton = bquoteSlider.querySelector('.swiper-button-prev');

        // pagination
        const fraction = bquoteSlider.querySelector('.swiper-fraction');
        const slides = slider.querySelectorAll('.swiper-slide');
        const slideCount = slides.length;
        fraction.textContent = `1 / ${slideCount}`;
        const type = paginationElement.classList.contains('progressbar') ? 'progressbar' : 'bullets';

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            pagination: {
                el: paginationElement,
                clickable: true,
                dynamicBullets: true,
                type: type,
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },

            breakpoints: {
                576: {
                    slidesPerView: 1.7,
                    // spaceBetween: 32,
                    centeredSlides: true,
                },
            },

            on: {
                slideChange: () => {
                    fraction.textContent = `${swiper.realIndex + 1} / ${slideCount}`;
                },
            },
        });

        swiper.on('slideChange', () => {
            const bodyText = bquoteSlider.querySelector('.quote-body');
            const newBodyText = bquoteSlider.querySelector('.hiddenSlideContent-' + swiper.activeIndex).innerHTML;
            bodyText.innerHTML = newBodyText;
            num = swiper.activeIndex + 1;
        });
    });
});
